import { find } from 'lodash';

Pollfish.store = (function store() {
  return {
    monitoring: {
      rejectedSurveys: {},
      reportedRejectionErrors: false,
      offersImpression: [],
    },
    sanityScreenouts: 0,
    userRejectedSurveys: [],
    initRespondentKnowledge(respondentKnowledge, extraTaxonomyProperties) {
      this.respondentKnowledge = respondentKnowledge || {
        taxonomyDevice: {},
        concepts: [],
        choiceSetBlockIds: [],
        choiceSetBlocks: [],
        questionAnswers: [],
        screeningQuestionAnswers: [],
      };
      this.respondentKnowledge.taxonomyDevice = {
        ...(this.respondentKnowledge.taxonomyDevice || {}),
        ...extraTaxonomyProperties,
      };
    },
    getRespondentKnowledge() {
      if (!this.respondentKnowledge) {
        this.respondentKnowledge = {
          taxonomyDevice: {},
          concepts: [],
          choiceSetBlockIds: [],
          choiceSetBlocks: [],
          questionAnswers: [],
          screeningQuestionAnswers: [],
        };
      }
      return this.respondentKnowledge;
    },
    addTaxonomyData(taxonomy) {
      const respondentKnowledge = this.getRespondentKnowledge();
      const taxonomyData = {
        ...taxonomy,
      };
      if (taxonomyData.dg_year_of_birth) {
        const currentYear = new Date().getFullYear();
        const userYear = parseInt(taxonomyData.dg_year_of_birth, 10);
        const currentAge = currentYear - userYear;
        taxonomyData.age = currentAge;
      }

      respondentKnowledge.taxonomyDevice = taxonomyData;
    },
    addAnsweredConcept(nodeId, concept) {
      const knowledge = this.respondentKnowledge;
      const nodeWithConcept = find(knowledge.concepts, ['nodeId', nodeId]);
      const selectedConceptId = concept.id.toString();

      if (!nodeWithConcept) {
        knowledge.concepts.push({
          nodeId,
          conceptIds: [concept.refId],
          conceptBackEndIds: [selectedConceptId],
        });
        return;
      }

      if (!nodeWithConcept.conceptIds.includes(concept.refId)) {
        nodeWithConcept.conceptIds.push(concept.refId);
        nodeWithConcept.conceptBackEndIds.push(selectedConceptId);
      }
    },
    addAnsweredChoiceSet(nodeRefId, choiceSetId, blockId) {
      const knowledge = this.respondentKnowledge;
      const nodeWithBlock = find(knowledge.choiceSetBlocks, [
        'nodeId',
        nodeRefId,
      ]);
      // const selectedConceptId = concept.id.toString();
      if (!knowledge.choiceSetBlockIds.includes(blockId)) {
        knowledge.choiceSetBlockIds.push(blockId);
      }
      // ΝΟΤΕ: these are not currently used anywhere
      if (!nodeWithBlock) {
        knowledge.choiceSetBlocks.push({
          nodeRefId,
          choiceSetIds: [choiceSetId],
        });
        return;
      }
      if (!nodeWithBlock.choiceSetIds.includes(choiceSetId)) {
        nodeWithBlock.choiceSetIds.push(choiceSetId);
      }
    },
    getSelectedOffer() {
      return this.selectedOffer;
    },
    setSelectedOffer(offer) {
      this.selectedOffer = offer;
    },
    getIsPreviousPageGDPR() {
      return this.isPreviousPageGDPR;
    },
    setIsPreviousPageGDPR(isGDPR) {
      this.isPreviousPageGDPR = isGDPR;
    },
  };
})();

export default Pollfish.store;
